"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.withModal = exports.ModalRoot = exports.useModal = exports.ModalContext = void 0;
const react_1 = __importStar(require("react"));
const Modal_1 = __importDefault(require("./Modal"));
exports.ModalContext = react_1.createContext({});
const ModalProvider = ({ children }) => {
    const [modal, setModal] = react_1.useState(() => null);
    const showModal = react_1.useCallback((modalType) => {
        setModal(modalType);
    }, []);
    const hideModal = react_1.useCallback(() => {
        setModal(() => null);
    }, []);
    const state = {
        ModalType: modal,
        showModal,
        hideModal
    };
    return react_1.default.createElement(exports.ModalContext.Provider, { value: state }, children);
};
exports.useModal = () => react_1.useContext(exports.ModalContext);
exports.ModalRoot = () => {
    const { ModalType } = react_1.useContext(exports.ModalContext);
    return react_1.default.createElement(react_1.default.Fragment, null, ModalType || null);
};
exports.withModal = (Component) => {
    return (props) => {
        const { onClose } = props;
        return (react_1.default.createElement(Modal_1.default, { isOpen: true, content: react_1.default.createElement(Component, Object.assign({}, props)), onClose: () => onClose() }));
    };
};
exports.default = ModalProvider;
